import { render, staticRenderFns } from "./merge_failed_pipeline_confirmation_dialog.vue?vue&type=template&id=52c97dc5"
import script from "./merge_failed_pipeline_confirmation_dialog.vue?vue&type=script&lang=js"
export * from "./merge_failed_pipeline_confirmation_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports